import React from 'react';
import { Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SvgIcon from '../../../Helpers/Svg/SvgIcon';

import "./Privacy.scss";

export default function Privacy({ data, customData }) {
  const { title, description, iconName } = !customData ? data : customData;
  
  return (
    <Row className="privacy-wrapper">
      <Container>
        <div className="privacy-container">
          <div className="privacy-content">
            <h2>{title}</h2>
            <p>{description}</p>
            <SvgIcon iconName={iconName} viewBox={"0 0 40 40"} />
          </div>
        </div>
      </Container>
    </Row>
  );
}

Privacy.propTypes = {
  data: PropTypes.object.isRequired,
  customData: PropTypes.object,
}